import React,{ FC } from "react";
import useIntercomChat, { IntercomParams } from "./useIntercomChat";

const Intercom: FC<IntercomParams> = (props = {}) => {
  useIntercomChat(props);
  return null;
}

export default Intercom;